import React from "react";
import useAppStore from "../../Store/SearchStore";
import { PillButton } from "../ui/Button/index";
import { categories } from "./categories";
import { useTranslation } from "react-i18next";

const SentencePills = () => {
  const { t } = useTranslation();
  const { setSearchText } = useAppStore();

  const handleAction = (descriptionKey) => {
    const translatedSentence = t(descriptionKey);
    // Wrap the translated sentence in the mention span format
    const mentionHtml = `<span data-type='mention' class='mention' data-id='1' data-label='${translatedSentence}'>${translatedSentence}</span>`;
    setSearchText(mentionHtml);
  };

  return (
    <div className="h-screen flex flex-col justify-center mx-10">
      {" "}
      <div className="w-full text-6xl font-bold tracking-wide text-center leading-[72px] text-red-500 max-md:mt-10 max-md:max-w-full max-md:text-4.5xl max-md:leading-[60px]">
        {t("career.iWantGiftFor")}
      </div>
      <div className="flex justify-start">
        <div className="flex gap-3 justify-center md:flex-wrap px-20 mt-12 w-full text-base font-bold leading-6 text-center whitespace-nowrap text-neutral-green-900 max-md:flex-wrap max-md:px-5 max-md:mt-10 max-md:max-w-full">
          {categories.map((category) => (
            <PillButton
              key={category.name}
              variant="customCategory"
              size="sm"
              onClick={() => handleAction(category.descriptionKey)}
              className={`shadow ${category.bgColor} text-neutral-green-900 `}
            >
              {t(category.name)}
            </PillButton>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SentencePills;
